var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyes4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 124.3 35.9",
    style: {
      enableBackground: "new 0 0 124.3 35.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#DD6B7C;}\n\t.st2{fill:url(#SVGID_00000059298757400328235060000006312225452287390852_);}\n\t.st3{fill:url(#SVGID_00000096760623244221541200000006575041482958459011_);}\n\t.st4{fill:url(#SVGID_00000133502062239439609450000011086772654142532772_);}\n\t.st5{fill:#FFFFFF;}\n\t.st6{opacity:0.6;fill:#D177B8;enable-background:new    ;}\n\t.st7{fill:#DD4C6A;}\n\t.st8{fill:#4E1B3D;}\n\t.st9{fill:url(#SVGID_00000123424886740021508200000017823422944344987319_);}\n\t.st10{fill:url(#SVGID_00000122680592717295896780000016380422136037828488_);}\n\t.st11{fill:url(#SVGID_00000061446788017972763550000018227517884150820030_);}\n\t.st12{fill:url(#SVGID_00000155860732428375922960000009513175451552740244_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 158.5406,
    y1: 91.4872,
    x2: 158.5406,
    y2: 124.094,
    gradientTransform: "matrix(0.9918 0.1277 0.1277 -0.9918 -65.5877 106.3286)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEE2FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#BDC9FB"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.6,30.9c0.4,3.1,19.9,7.4,28.8,2c9.6-5.8,12.6-23.3,1.3-27.7C105.5,0.8,83.9,7.9,86.6,30.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M86.3,27.8c0,0,2.1,3.8,3.5,5.4c0,0-3.7-0.8-4-1.9S86.3,27.8,86.3,27.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M95.4,34.7c0,0,12.9,2.7,21-3.8c7-5.6,7.4-11.4,7.4-11.4s0.9,7.7-7.3,13.2S95.4,34.7,95.4,34.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075849906976136137710000000369002211931408049_",
    gradientUnits: "userSpaceOnUse",
    x1: 156.8624,
    y1: 98.0623,
    x2: 156.8624,
    y2: 122.2623,
    gradientTransform: "matrix(0.9918 0.1277 0.1277 -0.9918 -65.5877 106.3286)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3780A9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#153364"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000075849906976136137710000000369002211931408049_)"
    },
    d: "M116,18.7c-0.9,6.6-6.9,11.3-13.5,10.4 s-11.3-6.9-10.4-13.5C92.9,9,99,4.3,105.6,5.1C112.2,6,116.9,12,116,18.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000153664377684048975200000004330914872556238527_",
    gradientUnits: "userSpaceOnUse",
    x1: 156.8625,
    y1: 98.7697,
    x2: 156.8625,
    y2: 121.5553,
    gradientTransform: "matrix(0.9918 0.1277 0.1277 -0.9918 -65.5877 106.3286)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4997FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#021F5E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000153664377684048975200000004330914872556238527_)"
    },
    d: "M115.3,18.6c-0.8,6.2-6.5,10.6-12.7,9.8 S92,21.9,92.8,15.7S99.3,5,105.5,5.8S116.1,12.3,115.3,18.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000019662269207053027160000012709696799225178772_",
    gradientUnits: "userSpaceOnUse",
    x1: 156.8625,
    y1: 102.7578,
    x2: 156.8625,
    y2: 117.5304,
    gradientTransform: "matrix(0.9918 0.1277 0.1277 -0.9918 -65.5877 106.3286)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00629B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#000027"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000019662269207053027160000012709696799225178772_)"
    },
    d: "M111.4,18.1c-0.5,4-4.2,6.9-8.3,6.4 c-4-0.5-6.9-4.2-6.4-8.3c0.5-4,4.2-6.9,8.3-6.4C109,10.3,111.9,14,111.4,18.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M112.3,16.6c-0.8,0.5,2.5,1.1,5.1,0.5c2.3-0.6,3.5-1.9,3.4-2.1C120.6,14.6,115.5,14.4,112.3,16.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M110.4,17c-0.9-0.4-2-0.1-2.1,0.4s1,1.3,1.5,1.1C110.3,18.3,110.9,17.2,110.4,17z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M86.4,25.7c0,0,5.2-15.4,20.2-16.6S124,16,124,16l-0.1-0.7c0,0-0.2-10.5-17.2-11.1 C89.8,3.5,86.3,21.9,86.4,25.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M87.9,17.9c0,0,5.4-17.8,19.9-17.9c13-0.1,15.5,12.1,15.5,12.1S106-3.1,87.9,17.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M86.6,23.3c0,0,2.6-12.8,18.9-15.2s18.4,7.1,18.4,7.1s3-7.1-9.4-9.4C99.3,2.9,87.7,13,86.6,23.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158722452577846295710000005224191053776864438_",
    gradientUnits: "userSpaceOnUse",
    x1: -1295.0778,
    y1: -95.6814,
    x2: -1295.0778,
    y2: -63.0746,
    gradientTransform: "matrix(-0.9918 0.1277 -0.1277 -0.9918 -1275.796 106.3286)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEE2FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#BDC9FB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158722452577846295710000005224191053776864438_)"
    },
    d: "M37.6,30.9c-0.4,3.1-19.9,7.4-28.8,2 C-0.8,27.1-3.8,9.6,7.5,5.2S40.4,7.9,37.6,30.9z"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38,27.8c0,0-2.1,3.8-3.5,5.4c0,0,3.7-0.8,4-1.9S38,27.8,38,27.8z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.9,34.7c0,0-12.9,2.7-21-3.8c-7-5.6-7.4-11.4-7.4-11.4s-0.9,7.7,7.3,13.2S28.9,34.7,28.9,34.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000032646349081665575030000003664372799348880040_",
    gradientUnits: "userSpaceOnUse",
    x1: -1296.7964,
    y1: -89.1052,
    x2: -1296.7964,
    y2: -64.9022,
    gradientTransform: "matrix(-0.9918 0.1277 -0.1277 -0.9918 -1275.796 106.3286)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3780A9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#153364"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000032646349081665575030000003664372799348880040_)"
    },
    cx: 20.2,
    cy: 17.1,
    r: 12.1
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170987298357467519020000005968971942200584075_",
    gradientUnits: "userSpaceOnUse",
    x1: -1296.7404,
    y1: -88.3901,
    x2: -1296.7404,
    y2: -65.6173,
    gradientTransform: "matrix(-0.9918 0.1277 -0.1277 -0.9918 -1275.796 106.3286)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4997FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#021F5E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000170987298357467519020000005968971942200584075_)"
    },
    d: "M8.9,18.6c0.8,6.2,6.5,10.6,12.7,9.8 s10.6-6.5,9.8-12.7S25,5,18.8,5.8C12.5,6.6,8.1,12.3,8.9,18.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000126315044760463421340000011660707042895928764_",
    gradientUnits: "userSpaceOnUse",
    x1: -1296.8396,
    y1: -84.4108,
    x2: -1296.8396,
    y2: -69.6383,
    gradientTransform: "matrix(-0.9918 0.1277 -0.1277 -0.9918 -1275.796 106.3286)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00629B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#000027"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000126315044760463421340000011660707042895928764_)"
    },
    d: "M12.9,18.1c0.5,4,4.2,6.9,8.3,6.4 c4-0.5,6.9-4.2,6.4-8.3c-0.5-4-4.2-6.9-8.3-6.4C15.2,10.3,12.4,14,12.9,18.1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M11.9,16.6c0.8,0.5-2.5,1.1-5.1,0.5c-2.3-0.6-3.5-1.9-3.4-2.1C3.7,14.6,8.8,14.4,11.9,16.6z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M13.9,17c0.9-0.4,2-0.1,2.1,0.4s-1,1.3-1.5,1.1C13.9,18.3,13.4,17.2,13.9,17z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M37.9,25.7c0,0-5.2-15.4-20.2-16.6S0.3,16,0.3,16l0.1-0.7c0,0,0.2-10.5,17.2-11.1 C34.4,3.5,37.9,21.9,37.9,25.7z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M36.4,17.9c0,0-5.4-17.8-19.9-17.9C3.5-0.1,1,12.1,1,12.1S18.2-3.1,36.4,17.9z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M37.6,23.3c0,0-2.6-12.8-18.9-15.2S0.3,15.2,0.3,15.2s-3-7.1,9.4-9.4C25,2.9,36.5,13,37.6,23.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyes4);
export default __webpack_public_path__ + "static/media/Eyes4.e4f8c798ef8114a6e096cc16bd39954e.svg";
export { ForwardRef as ReactComponent };